<template>

  <aside class="InsightCarousel">

    <Container>
      <h2 class="heading">{{ content.heading }}</h2>
    </Container>

    <HorizontalScroller v-if="content.insights && content.insights.length > 0"
      class="insightsScroller"
    >
      <Container class="insightsContainer">
        <Insight v-for="insight in content.insights"
          :key="insight._key"
          :content="insight"
          class="insight"
        />
      </Container>
    </HorizontalScroller>

  </aside>

</template>

<script>
import HorizontalScroller from '~/vue-components/shared/HorizontalScroller.vue'
import Insight from './Insight.vue'

export default {
  components: {
    HorizontalScroller,
    Insight
  },
  props: {
    content: Object,
  },
}
</script>

<style scoped>
.InsightCarousel {
  padding-top: var(--spacing-12);
  padding-bottom: var(--spacing-12);
}

.heading {
  font-weight: 600;
  font-size: var(--font-size-8);
  line-height: 1.3;
  color: var(--text-color-black);
  white-space: pre-line;
}

.insightsScroller {
  padding-top: var(--spacing-9);
  touch-action: manipulation;
}

.insightsContainer {
  display: flex;
  min-width: fit-content;
}

.insight {
  padding-right: var(--spacing-8);
}
</style>
